import * as React from "react"
import {
  ChakraProvider,
  Box,
  // Text,
  // Link,
  // VStack,
  // Code,
  // Grid,
  Container,
} from "@chakra-ui/react"
// import { ColorModeSwitcher } from "./ColorModeSwitcher"
// import { Logo } from "./Logo"
import ScrollLogo from "./components/ScrollLogo"
import Hero from "./components/Hero"
import Footer from "./components/Footer"
import theme from "./Theme"
import { BrowserRouter as Router, Routes, Route } from "react-router-dom"
import Solutions from "./pages/Solutions"
import Products from "./pages/Products"
import Cases from "./pages/Cases"
import About from "./pages/About"
import Contact from "./pages/Contact"

export const App = () => (
  <ChakraProvider theme={theme}>
    <Router>
      <ScrollLogo />
      <Box minH="100vh" display="flex" flexDirection="column">
        <Routes>
          <Route path="/" element={<Hero />} />
          <Route path="/solutions" element={<Solutions />} />
          <Route path="/products" element={<Products />} />
          <Route path="/cases" element={<Cases />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
        <Footer />
      </Box>
    </Router>
  </ChakraProvider>
)
